import type { BlissBasicCatalogPhoto, BlissBasicWizardStep } from '../config/blissBasicCatalog'
import { BLISS_BASIC_OPTION_CATEGORIES } from '../config/blissBasicOptionCategories'

export type { BlissBasicWizardStep } from '../config/blissBasicCatalog'

/** Customer-facing wizard steps — active, in-stock, categorized photos only. */
export function buildBlissBasicWizardSteps(photos: BlissBasicCatalogPhoto[]): BlissBasicWizardStep[] {
  return BLISS_BASIC_OPTION_CATEGORIES.map((cat) => ({
    categoryId: cat.id,
    step: cat.step,
    title: cat.title,
    subtitle: cat.subtitle,
    examples: cat.examples,
    photos: photos
      .filter(
        (p) =>
          p.optionCategory === cat.id &&
          p.active !== false &&
          p.inStock !== false,
      )
      .sort((a, b) => a.sortOrder - b.sortOrder),
  }))
}

export function blissBasicWizardHasAnyOptions(photos: BlissBasicCatalogPhoto[]): boolean {
  return buildBlissBasicWizardSteps(photos).some((s) => s.photos.length > 0)
}
